export { type TeamData, fetchTeamData } from '../src/teams/fetchTeamData';
